<template>
  <div class="retinuePage">
    <van-search
      v-if="userData.length<=0"
      v-model="searchKeyword"
      class="searchBox"
      id="searchHeight"
      placeholder="请输入搜索关键词"
      @input="onSearch"
      show-action
      shape="round"
    >
      <div slot="action" @click="onSearch">搜索</div>
    </van-search>
    <div class="list-content" :class="userData.length>0?'noSearch':''" id="list-content">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
      >
        <van-checkbox-group v-model="result">
          <van-cell-group>
            <van-cell
              v-for="(item, index) in retinueMainList"
              clickable
              :key="item.id"
              :title="`${item.realName}`"
              @click="toggle(index, item)"
              class="item"
            >
              <van-checkbox
                :name="item.realName"
                ref="checkboxes"
                slot="right-icon"
              />
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>
      </van-list>
    </div>
    <div class="roleBtn clearfix">
      <a href="javascript:void(0);" class="fl" @click="closeRetinuePicker"
        >取消</a
      >
      <a href="javascript:void(0);" class="fl" @click="saveRetinue">确认</a>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import newApi from "lodash";
export default {
  name: "retinueView",
  data() {
    return {
      searchName: "",
      searchKeyword: "", //搜索的姓名人员
      retinueTotal: "", //统计计算
      retinueMainList: [],
      retinueList: [], //随行人员列表
      result: [], //选择的随行人员列表
      retinuedata: [], //选中的随行人员列表
      cloneRetinuedata: [],
      retinuedataList: {},
      retinueIdList: [],
      retinueNameList: "",
      retinuePage: 0,
      pageSize: 99,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      clientType: "", //手机类型
    };
  },
  props: {
    retinueUids: {
      type: Array,
      default: () => [],
    },
    userData: {//人员数据
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    if(this.userData.length>0){
        this.retinueList = this.userData;
        this.retinueTotal=this.retinueList.length;
        this.viewLists();
        this.finished = true;
    }else{
      this.getRetinueList();
    }
  },
  methods: {
    toggle(index, item) {
      this.$refs.checkboxes[index].toggle();

      this.unique(item);
    },
    onSearch() {
      let _this = this;
      _this.searchName = _this.searchKeyword;
      _this.reloadPage();
    },
    onCancel() {
      let _this = this;
      this.searchName = "";
      _this.reloadPage();
    },
    getRetinueList() {
      let _this = this;
      if (
        _this.retinuePage != 0 &&
        _this.retinuePage * _this.pageSize >= parseInt(_this.retinueTotal)
      ) {
        return;
      }
      _this.retinuePage += 1;
      _this.$api.baseCommon.baseMsg.dictBox
        .staffPageList(_this.retinuePage, _this.pageSize, {
          realName: _this.searchName,
          enable: true,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.retinueTotal = parseInt(res.data.total);
            _this.retinueList = res.data.list;
            _this.viewLists();
            // 加载状态结束
            this.loading = false;
            if (_this.retinuePage * _this.pageSize >= _this.retinueTotal) {
              _this.finished = true;
              console.log("加载完成");
            } else {
              _this.getRetinueList();
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          this.finished = true;
          console.log(err);
        });
    },
    viewLists() {
      this.retinueMainList = this.retinueMainList.concat(this.retinueList);

      if (this.retinueMainList.length == this.retinueTotal) {
        let newArr = JSON.parse(
          window.sessionStorage.getItem("moreRetinueList")
        )
          ? JSON.parse(window.sessionStorage.getItem("moreRetinueList"))
          : [];

        if (newArr[0]) {
          for (let i = 0; i < newArr.length; i++) {
            for (let j = 0; j < this.retinueMainList.length; j++) {
              if (newArr[i].id == this.retinueMainList[j].id) {
                this.result.push(this.retinueMainList[j].realName);
                this.retinuedata.push(this.retinueMainList[j]);
              }
            }
          }
        }
      }
    },
    closeRetinuePicker() {
      this.retinuedata = JSON.parse(
        window.sessionStorage.getItem("moreRetinueList")
      )
        ? JSON.parse(window.sessionStorage.getItem("moreRetinueList"))
        : [];

      this.result = [];
      this.retinuedata.forEach((item) => {
        this.result.push(item.realName);
      });

      this.retinuedataList = "";
      this.$emit("setReview", "");
    },
    saveRetinue() {
      let _this = this;
      let arr1 = [];
      let arr2 = [];
      // let newArr = JSON.parse(window.sessionStorage.getItem("moreRetinueList"))
      //   ? JSON.parse(window.sessionStorage.getItem("moreRetinueList"))
      //   : [];
      // this.retinuedata = this.retinuedata.concat(newArr);
      // this.getNewArr(this.retinuedata);

      this.getNewArr(this.retinuedata);
      window.sessionStorage.setItem(
        "moreRetinueList",
        JSON.stringify(this.retinuedata)
      );
      console.log(this.retinuedata, "retinuedata11");

      _this.retinuedata.forEach((item) => {
        arr2.push(item.id);
        arr1.push(item.realName);
      });
      _this.retinueNameList = arr1.join("，");
      _this.retinueIdList = arr2;
      _this.retinuedataList = {};
      _this.retinuedataList.ids = _this.retinueIdList;
      _this.retinuedataList.names = _this.retinueNameList;

      this.$emit("setReview", _this.retinuedataList);
    },
    getNewArr(dataArray) {
      //数组去重
      let newArr = [];
      for (var i = 0; i < dataArray.length; i++) {
        var flag = true;
        for (var j = 0; j < newArr.length; j++) {
          if (dataArray[i].id == newArr[j].id) {
            flag = false;
            break;
          }
        }
        if (flag) {
          newArr.push(dataArray[i]);
        }
      }

      this.retinuedata = newArr;
    },
    unique(item) {
      //数组去重
      let _this = this;
      if (_this.retinuedata[0]) {
        let index = _this.retinuedata.findIndex(
          (selectItem) => selectItem.id == item.id
        );

        if (index < 0) {
          _this.retinuedata.push(item);
        } else {
          _this.retinuedata.forEach((selectVal, selectIndex) => {
            if (selectVal.id == item.id) {
              _this.retinuedata.splice(selectIndex, 1);
            }
          });
        }
      } else {
        _this.retinuedata.push(item);
      }
    },
    reloadPage() {
      this.retinuePage = 0;
      this.retinueMainList = [];
      // this.result = [];
      // this.retinuedata = [];
      this.loading = false; //是否处于加载状态
      this.finished = false; //是否已加载完所有数据
      this.getRetinueList();
    },
    // onLoad() {
    //   // 异步更新数据
    //   setTimeout(() => {
    //       this.getRetinueList();
    //   }, 300);
    // },
  },
};
</script>
<style lang="less" >
.retinuePage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .searchBox {
    padding: 0 8px;
    margin-bottom: 10px;
  }
  .list-content {
    height: calc(100% - 45px);
    overflow: scroll;
    padding-bottom: 60px;
    .list-item {
      .item {
        height: 45px;
      }
    }
  }
  .roleBtn {
    position: fixed;
    width: 100%;
    font-size: 15px;
    text-align: center;
    color: #333;
    height: 45px;
    bottom: 0;
    background-color: #fff;
    z-index: 10001 !important;
    border-top: 1px solid #f6f6f6;
    a:first-child {
      color: rgb(235, 199, 155);
      border-right: 1px solid #f6f6f6;
    }
    a {
      display: inline-block;
      width: 50%;
      height: 100%;
      line-height: 45px;
      color: #07c160;
      font-size: 14px;
      box-sizing: border-box;
    }
  }
}
</style>